<template>
  <div class="header-container">
    <div class="header-content">
      <!-- Logo区域 -->
      <div class="brand-area">
        <div class="logo-icon">📋</div>
        <div class="brand-text">
          <div class="brand-title">多人填表数据管理平台</div>
          <div class="brand-subtitle">简单易用的个性化数据收集服务</div>
        </div>
      </div>
      
      <!-- 右侧操作区 -->
      <div class="header-actions">
        <div class="user-info" v-if="username">
          <i class="el-icon-user"></i>
          <span>{{name || username}}</span>
        </div>
        <el-button @click="logout" class="logout-btn" size="small">
          <i class="el-icon-switch-button"></i>
          <span>退出登录</span>
        </el-button>
      </div>
    </div>

    <!-- 修改资料弹窗 -->
    <el-dialog width="400px" :close-on-click-modal="false" title="修改用户资料" :visible.sync="editDialogVisible" custom-class="custom-dialog">
      <div class="edit-form">
        <div class="form-row">
          <label>{{lable}}</label>
          <el-input v-model="content" autocomplete="off" :placeholder="'请输入' + lable" autofocus></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cacelEdit">取 消</el-button>
        <el-button type="primary" @click="saveContent" class="btn-primary-custom">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        username: '',
        name: '',
        school: '',
        content: '',
        lable: '',
        source: '',
        editDialogVisible: false,
        url: this.HOST_URL + '/images/logo.jpg'
      }
    },
    created() {
      this.username = this.$session.get('USERNAME')
      this.name = this.$session.get('NAME')
    },
    mounted() {
      console.log('monted:' + this.username)
      if (this.isEmpty(this.username)) {
        this.$router.push('/')
      }
    },
    methods: {
      logout() {
        let that = this
        this.$confirm('确定要退出系统吗？', '退出确认', {
          confirmButtonText: '确定退出',
          cancelButtonText: '取消',
          type: 'warning',
          confirmButtonClass: 'el-button--danger'
        }).then(() => {
          var requestUrl = '/form/web/_logout.jsp'
          this.axios.get(requestUrl, {
            params: { username: that.username }
          }).then(function(response) {
            that.$session.set('USERNAME', '')
            that.$router.push('/')
            that.$message.success('已安全退出系统')
          }).catch(function(error) {
            console.log(error)
          })
        }).catch(() => {})
      },
      helpMe() {
        const { href } = this.$router.resolve({ name: 'help' })
        window.open(href, '_blank')
      },
      editProfile(source) {
        if (source === 'school_name') {
          this.content = this.school
          this.lable = '学校'
          this.source = 'school_name'
        } else {
          this.content = this.teacher_name
          this.lable = '姓名'
          this.source = 'teacher_name'
        }
        this.editDialogVisible = true
      },
      cacelEdit() {
        this.editDialogVisible = false
      },
      saveContent() {
        if (this.content === '') {
          this.$message.error('内容不能为空！')
          return
        }
        let that = this
        var requestUrl = '/score/web/_update_profile.jsp'
        if (this.source === 'school_name') {
          this.school = this.content
          that.$session.set('SCHOOL', this.content)
        } else {
          this.teacher_name = this.content
          that.$session.set('TEACHER_NAME', this.content)
        }
        this.axios.get(requestUrl, {
          params: { username: that.username, content: that.content, source: that.source }
        }).then(function(response) {
          that.content = ''
          that.editDialogVisible = false
          that.$message.success('修改成功！')
        }).catch(function(error) {
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>
  /* 头部容器 - 蓝色渐变背景 */
  .header-container {
    background: linear-gradient(135deg, #1485FB 0%, #0066cc 50%, #0052a3 100%);
    box-shadow: 0 2px 10px rgba(20, 133, 251, 0.2);
    position: relative;
    overflow: hidden;
  }

  /* 装饰性圆形 */
  .header-container::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -5%;
    width: 200px;
    height: 200px;
    background: rgba(255,255,255,0.05);
    border-radius: 50%;
  }

  .header-container::after {
    content: '';
    position: absolute;
    bottom: -30%;
    left: 10%;
    width: 150px;
    height: 150px;
    background: rgba(255,255,255,0.03);
    border-radius: 50%;
  }

  /* 头部内容 */
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 30px;
    position: relative;
    z-index: 1;
  }

  /* Logo区域 */
  .brand-area {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .logo-icon {
    font-size: 36px;
    background: rgba(255,255,255,0.15);
    width: 50px;
    height: 50px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);
  }

  .brand-text {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .brand-title {
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    letter-spacing: 1px;
  }

  .brand-subtitle {
    font-size: 13px;
    color: rgba(255,255,255,0.8);
    letter-spacing: 2px;
  }

  /* 右侧操作区 */
  .header-actions {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(255,255,255,0.9);
    font-size: 14px;
    background: rgba(255,255,255,0.1);
    padding: 8px 16px;
    border-radius: 20px;
    backdrop-filter: blur(10px);
  }

  .user-info i {
    font-size: 16px;
  }

  /* 退出按钮 */
  .logout-btn {
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.3);
    color: #fff;
    border-radius: 6px;
    padding: 8px 16px;
    transition: all 0.3s ease;
  }

  .logout-btn:hover {
    background: rgba(255,255,255,0.25);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .logout-btn i {
    margin-right: 5px;
  }

  /* 弹窗样式 */
  ::v-deep .custom-dialog .el-dialog__header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    padding: 15px 20px;
  }

  ::v-deep .custom-dialog .el-dialog__title {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
  }

  ::v-deep .custom-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255,255,255,0.8);
  }

  .edit-form {
    padding: 10px 0;
  }

  .form-row {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .form-row label {
    font-size: 14px;
    color: #333;
    font-weight: 500;
  }

  .btn-primary-custom {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    border: none;
  }

  /* 响应式 */
  @media (max-width: 768px) {
    .header-content {
      padding: 12px 15px;
    }

    .logo-icon {
      width: 40px;
      height: 40px;
      font-size: 28px;
    }

    .brand-title {
      font-size: 16px;
    }

    .brand-subtitle {
      font-size: 11px;
    }

    .user-info span {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/head.vue